module["exports"] = [
  "#{street_title} #{street_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/address/street_name.js
 ** module id = 727
 ** module chunks = 0
 **/